import { render } from "./App.vue?vue&type=template&id=23713341"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=23713341&lang=scss"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/.pnpm/vue-loader@17.0.1_vue@3.2.41+webpack@5.74.0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__